module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C134"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('em')]), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/06_List_of#page_ix"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Acknowle#page_xi"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduc#page_1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_1__The_L#page_21"
    }
  }, [_vm._v("1. The Logic of Political Monopolies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_2__Found#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Foundations of Political Monopolies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_3__Coord#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Coordinating Monopolies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_4__Estab#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Establishing Political Monopolies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_5__Effec#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Effects of Political Monopolies")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_6__Monop#page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Monopoly Collapse")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_7__The_R#page_217",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Rise and Fall of Bosses and Reformers")])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix#page_237",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Notes#page_245",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Referenc#page_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])]), _vm._v(" "), _c('p', {
    staticClass: "C135"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Index#page_279",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d06ac474","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Contents.vue
// module id = 66
// module chunks = 0